export default "__VITE_ASSET__16219bb6__"